import { parseJsonObject, parseString } from "@de-xima/xima-common-js-lang";

/** @type {Window | undefined} */
let newWindow;

/**
 * Open the form by the given path.
 * @param path {string} The path of the form.
 * @param isUserLoggedIn {boolean} Whether the user is logged in.
 */
export function openForm(path, isUserLoggedIn) {
  if (!isUserLoggedIn) {
    window.open(path, "_blank");
    return;
  }

  newWindow = window.open("about:blank", "_blank") ?? undefined;
  rcPrepareFormUrl?.([{ name: "path", value: path }]);
}

/**
 * Callback function for the form URL preparation.
 * @param {PrimeFaces.ajax.PrimeFacesArgs} args The PrimeFaces arguments object with the data received from the server.
 */
export function onFormUrlPrepareComplete(args) {
  if (newWindow) {
    const data = parseJsonObject(args.formAccessData);
    let formPath = parseString(data.formPath);
    const portalAlias = parseString(data.portalAlias);

    if (portalAlias) {
      formPath = appendParameterToUrl(formPath, "portal_alias", portalAlias);
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = formPath;

    newWindow.document.body.appendChild(form);
    form.submit();
  }
}

/**
 * Appends a given url parameter to the URL with the given key and value.
 * @param {string} url the URL to append the parameter to.
 * @param {string} urlParameterKey the key of the parameter to append.
 * @param {string} urlParameterValue the value of the parameter to append.
 * @returns {string} The URL with the appended parameter.
 */
export function appendParameterToUrl(url, urlParameterKey, urlParameterValue) {
  const urlObj = new URL(url, window.location.origin);
  urlObj.searchParams.set(urlParameterKey, urlParameterValue);
  return urlObj.toString();
}
